module.exports = __webpack_public_path__ + "img/0-admin.32783148.png";